import {
	Button,
	Col,
	DatePicker,
	Form,
	Input,
	InputNumber,
	Popconfirm,
	Row,
	Select,
	Upload,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import { UploadOutlined } from "@ant-design/icons";

const LogisticsTrip = (props) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [clientOptions, setClientOptions] = useState([]);
	const [truckOptions, setTruckOptions] = useState([]);
	const [driverOptions, setDriverOptions] = useState([]);
	const [mineOptions, setMineOptions] = useState([]);
	const [materialOptions, setMaterialOptions] = useState([]);
	const [hasReceivedDate, setHasReceivedDate] = useState(false);
	const [defaultValueEvidence, setDefaultValueEvidence] = useState([]);
	const [evidenceRemoved, setEvidenceRemoved] = useState(false);
	const [evidenceAdded, setEvidenceAdded] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		Promise.all([
			getClients(),
			getDrivers(),
			getTrucks(),
			getMines(),
			getMaterials(),
		]).then(() => {
			getTrip();
		});
	}, []);

	const getClients = async () => {
		const url = api + "/logistics/client/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setClientOptions(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getDrivers = async () => {
		const url = api + "/logisticsdriver/list";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let driverList = [];
			data.map((item) => {
				driverList.push({
					label: item.name,
					value: item._id,
				});
			});
			setDriverOptions(driverList);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getTrucks = async () => {
		const url = api + "/logisticstruck/list";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let truckList = [];
			data.map((item) => {
				truckList.push({
					label: item.number,
					value: item._id,
				});
			});
			setTruckOptions(truckList);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getMines = async () => {
		const url = api + "/logistics/mine/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setMineOptions(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getMaterials = async () => {
		const url = api + "/logistics/material/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setMaterialOptions(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getTrip = async () => {
		const url = api + "/logisticstrip/get/jap/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			let duration = "0";
			if (data.startedDate && data.receivedDate) {
				var diffMs = new Date(data.receivedDate) - new Date(data.startedDate);
				var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
				var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
				duration = `${diffHrs} hours, ${diffMins} minutes`;
			}

			setInitialValues({
				...initialValues,
				mine: { value: data.mineId._id, label: data.mineId.name },
				material: { value: data.materialId._id, label: data.materialId.name },
				client: { value: data.clientId._id, label: data.clientId.name },
				truck: data.truck._id,
				driver: data.driver._id,
				ticket: data.ticket,
				quantity: data.quantity,
				duration: duration,
				startedDate: dayjs(data.startedDate),
				receivedDate: data.receivedDate ? dayjs(data.receivedDate) : undefined,
			});
			setHasReceivedDate(data.receivedDate ? true : false);

			setLoadingForm(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get truck");
			console.error(err.message);
			return null;
		}
	};

	const deleteTrip = async () => {
		setLoading(true);

		const url = api + "/logisticstrip/delete/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.delete(url);
			openNotification("info", "Info", "Trip Deleted");
			setLoading(false);
			props.history.push("/logistics/dashboard");
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const addEvidence = async (values) => {
		const formData = new FormData();

		if (evidenceAdded && values.evidence && values.evidence.length > 0) {
			formData.append("evidence", values.evidence[0].originFileObj);
		}

		if (evidenceAdded) {
			try {
				const url = api + `/logisticstrip/add/images/${props.match.params.id}`;
				const token = localStorage.getItem("token");
				axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
				const config = {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				};

				const { data } = await axios.post(url, formData, config);
				if (data.success) {
					openNotification("success", "Success", "Trip updated");

					setTimeout(() => {
						setLoading(false);
						props.history.push("/logistics/dashboard");
					}, 2000);
				} else {
					setLoading(false);
					openNotification("error", "Error", data.message);
				}
			} catch (err) {
				setLoading(false);
				openNotification(
					"error",
					"Error",
					"Error while trying to add evidence"
				);
				console.error(err.message);
				return null;
			}
		}
	};

	const updateTrip = async (data) => {
		const trip = {
			ticket: data.ticket,
			mine: data.mine.label,
			mineId: data.mine.value,
			material: data.material.label,
			materialId: data.material.value,
			client: data.client.label,
			clientId: data.client.value,
			truck: data.truck,
			driver: data.driver,
			quantity: data.quantity,
			startedDate: data.startedDate
				? dayjs(data.startedDate).toDate()
				: undefined,
			receivedDate: data.receivedDate
				? dayjs(data.receivedDate).toDate()
				: undefined,
		};

		try {
			let url = api + "/logisticstrip/update/jap/" + props.match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.patch(url, trip);
			if (evidenceAdded && !evidenceRemoved) {
				addEvidence(data);
			} else {
				openNotification("success", "Success", "Trip updated");
				setTimeout(() => {
					setLoading(false);
					props.history.push("/logistics/dashboard");
				}, 2000);
			}
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update trip");
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		updateTrip(values);
	};

	const onChangeStartedDate = (date) => {
		let duration = "0";
		const receivedDate = form.getFieldValue("receivedDate");
		if (date && receivedDate) {
			const start = dayjs(date).toDate();
			const received = dayjs(receivedDate).toDate();
			var diffMs = new Date(received) - new Date(start);
			var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
			var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
			duration = `${diffHrs} hours, ${diffMins} minutes`;
		}
		form.setFieldValue("duration", duration);
	};

	const onChangeReceivedDate = (date) => {
		let duration = "0";
		const startedDate = form.getFieldValue("startedDate");
		if (date && startedDate) {
			const start = dayjs(startedDate).toDate();
			const received = dayjs(date).toDate();
			var diffMs = new Date(received) - new Date(start);
			var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
			var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
			duration = `${diffHrs} hours, ${diffMins} minutes`;
		}
		form.setFieldValue("duration", duration);
	};

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	};

	const onChangeEvidence = ({ file }) => {
		if (file.status === "removed") {
			setEvidenceRemoved(true);
			setEvidenceAdded(false);
		}
		if (!file.status) {
			setEvidenceAdded(true);
			setEvidenceRemoved(false);
		}
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Ticket"
							name="ticket"
							rules={[
								{
									required: true,
									message: "Ticket is required",
								},
							]}
						>
							<Input
								size="large"
								disabled={
									localStorage.getItem("email") !== "eliud@gmail.com" &&
									localStorage.getItem("email") !== "ec@57concrete.com" &&
									localStorage.getItem("email") !== "pc@57concrete.com" &&
									localStorage.getItem("email") !== "gg@57xgroup.com" &&
									localStorage.getItem("email") !== "scale@filegonia.com" &&
									localStorage.getItem("email") !== "jc@57concrete.com" &&
									localStorage.getItem("email") !== "reyesss22@icloud.com" &&
									localStorage.getItem("email") !== "office@57logistics.com"
								}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Mine"
							name="mine"
							rules={[
								{
									required: true,
									message: "Please select a mine",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select mine`}
								size="large"
								options={mineOptions}
								style={{
									width: "100%",
								}}
								labelInValue
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Driver"
							name="driver"
							rules={[
								{
									required: true,
									message: "Please select a driver",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select driver`}
								size="large"
								options={driverOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Truck"
							name="truck"
							rules={[
								{
									required: true,
									message: "Please select a truck",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select truck`}
								size="large"
								options={truckOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Material"
							name="material"
							rules={[
								{
									required: true,
									message: "Please select a material",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select material`}
								size="large"
								options={materialOptions}
								style={{
									width: "100%",
								}}
								labelInValue
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Client"
							name="client"
							rules={[
								{
									required: true,
									message: "Please select a client",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select client`}
								size="large"
								options={clientOptions}
								style={{
									width: "100%",
								}}
								labelInValue
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Started Date" name="startedDate">
							<DatePicker
								format={"MM/DD/YYYY hh:mm A"}
								size="large"
								style={{ width: "100%" }}
								showTime
								allowClear={false}
								disabled={
									localStorage.getItem("email") !== "eliud@gmail.com" &&
									localStorage.getItem("email") !== "ec@57concrete.com" &&
									localStorage.getItem("email") !== "pc@57concrete.com" &&
									localStorage.getItem("email") !== "gg@57xgroup.com" &&
									localStorage.getItem("email") !== "scale@filegonia.com" &&
									localStorage.getItem("email") !== "jc@57concrete.com" &&
									localStorage.getItem("email") !== "reyesss22@icloud.com" &&
									localStorage.getItem("email") !== "office@57logistics.com"
								}
								onChange={onChangeStartedDate}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Received Date" name="receivedDate">
							<DatePicker
								format={"MM/DD/YYYY hh:mm A"}
								showTime
								size="large"
								style={{ width: "100%" }}
								allowClear={false}
								disabled={
									(localStorage.getItem("email") !== "eliud@gmail.com" &&
										localStorage.getItem("email") !== "ec@57concrete.com" &&
										localStorage.getItem("email") !== "pc@57concrete.com" &&
										localStorage.getItem("email") !== "gg@57xgroup.com" &&
										localStorage.getItem("email") !== "scale@filegonia.com" &&
										localStorage.getItem("email") !== "jc@57concrete.com" &&
										localStorage.getItem("email") !== "reyesss22@icloud.com" &&
										localStorage.getItem("email") !==
											"office@57logistics.com") ||
									!hasReceivedDate
								}
								onChange={onChangeReceivedDate}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Duration" name="duration">
							<Input size="large" readOnly disabled />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Quantity"
							name="quantity"
							rules={[
								{
									required: true,
									message: "Quantity must be filled",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, "")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Evidence"
							name="evidence"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".png, .jpg, .jpeg"
								defaultFileList={defaultValueEvidence}
								onChange={onChangeEvidence}
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							size="large"
						>
							Save
						</Button>
					</Col>
					{(localStorage.getItem("email") === "eliud@gmail.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "vm@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "scale@filegonia.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "reyesss22@icloud.com" ||
						localStorage.getItem("email") === "office@57logistics.com") && (
						<Col>
							<Popconfirm
								title="Delete trip"
								description="Are you sure to delete this trip?"
								okText="Yes"
								cancelText="No"
								onConfirm={deleteTrip}
							>
								<Button
									danger
									type="primary"
									htmlType="button"
									loading={loading}
									size="large"
								>
									Delete
								</Button>
							</Popconfirm>
						</Col>
					)}
				</Row>
			</Form>
		);
	};

	return (
		<Layout
			title="Logistics Trip"
			description="Edit Logistics Trip"
			type="medium"
		>
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default LogisticsTrip;
